
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Control recorrido vehiculo</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">



    <div class="form-group">
      <label for="exampleInputEmail1">Digite la placa del vehiculo</label>
      <input type="text" class="form-control" placeholder="Enter Placa" [(ngModel)]="filtro_linea">
    </div>
    <div class="form-group">
      <label>Seleccione si la entrega fue exitosa</label>
      <select class="form-control" [(ngModel)]="entrega">
        <option [value]="1">Entregado</option>
        <option [value]="0">No entregado</option>
        <option [value]="2">Avería</option>
      </select>
    </div>

    <div class="form-group">
      <label for="message-text" class="col-form-label">Observaciones</label>
      <textarea class="form-control" id="message-text" [(ngModel)]="observaciones"></textarea>
    </div>



  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="open(1)">Capture</button>
  </div>


